const UserInterestsStatusStorageKey = 'user-interests-status'

export enum UserInterestsStatus {
  InProgress = 'IN_PROGRESS',
  Done = 'DONE',
}

export const useUserInterestsStatus = () => {
  const userInterestsStatus = localStorage.getItem(
    UserInterestsStatusStorageKey
  )

  const setUserInterestsStatus = (nextState: UserInterestsStatus) => {
    localStorage.setItem(UserInterestsStatusStorageKey, nextState)
  }

  return {
    userInterestsStatus,
    setUserInterestsStatus,
  }
}
